delete window.module;
